import React, { useMemo, useState } from 'react';
import { Button, Divider, Icon, Menu, MenuItem } from '@material-ui/core';
export const PlatformMenuItems = [
    { value: 'sites', label: 'Site Builder', divider: false },
    { value: 'workflows', label: 'Workflow Editor', divider: false },
    { value: 'queries', label: 'Query Builder', divider: false },
    { value: 'apis', label: 'API Builder', divider: false },
    { value: 'forms', label: 'Form Builder', divider: false },
    { value: 'entities', label: 'Entity Data Model', divider: false },
    { value: '', label: '', divider: true },
    { value: 'groups', label: 'Groups', divider: false },
    { value: 'users', label: 'Users', divider: false },
    { value: 'reports', label: 'Reports', divider: false }
];
function getLabel(value) {
    var _a;
    return ((_a = PlatformMenuItems.find(item => item.value === value)) === null || _a === void 0 ? void 0 : _a.label) || '';
}
const PlatformMenuButton = ({ value, onChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const label = useMemo(() => getLabel(value), [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { size: 'large', color: 'inherit', endIcon: React.createElement(Icon, null, "arrow_drop_down"), onClick: (event) => {
                setAnchorEl(event.currentTarget);
            } }, label),
        React.createElement(Menu, { keepMounted: true, id: 'panel-menu', open: !!anchorEl, anchorEl: anchorEl, onClose: () => setAnchorEl(null) }, PlatformMenuItems.map((item, index) => item.divider ? (React.createElement(Divider, { key: index })) : (React.createElement(MenuItem, { key: index, selected: item.value === value, onClick: () => {
                onChange === null || onChange === void 0 ? void 0 : onChange(item.value);
                setAnchorEl(null);
            } }, item.label))))));
};
export default PlatformMenuButton;
//# sourceMappingURL=PlatformMenuButton.js.map